import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
import FundingLabArea from "../components/FundingLabArea";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const FundingLab = () => {
  return (
    <>
      <SEO canonical="/fundinglab" {...PAGES["/fundinglab"]} />
      {/* Navigation Bar */}
      <NavBarThree />

      {/* Navigation Bar */}
      <Breadcrumb title={"Evolvelab Funding Lab"} />

      {/* Service Details Area */}
      <FundingLabArea />

      {/* Footer One */}
      <FooterFour />
    </>
  );
};

export default FundingLab;
